import { createContext, useContext, useEffect, useState } from "react";
import { useWindowSize } from "usehooks-ts";

export function useDevicePixelRatio() {
  const [ratio, setRatio] = useState(devicePixelRatio);

  useEffect(() => {
    const media = matchMedia(`screen and (resolution: ${ratio}dppx)`);
    const update = () => setRatio(devicePixelRatio);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [ratio]);

  return ratio;
}

export type ScreenType = typeof ScreenType.DESKTOP | typeof ScreenType.MOBILE;

export namespace ScreenType {
  export const DESKTOP = Symbol("desktop");
  export const MOBILE = Symbol("mobile");
}

export function getScreenType(
  size: { width: number; height: number },
  mobileMaxWidth: number,
): ScreenType {
  if (size.width <= mobileMaxWidth) {
    return ScreenType.MOBILE;
  }
  return ScreenType.DESKTOP;
}

// Portal builder can force mobile display mode that's not reliant on screen width
export const ScreenTypeOverrideContext = createContext<ScreenType | null>(null);

export function useScreenType(mobileMaxWidth = 600): ScreenType {
  const override = useContext(ScreenTypeOverrideContext);
  const size = useWindowSize();
  if (override !== null) {
    return override;
  }
  return getScreenType(size, mobileMaxWidth);
}
